<iframe class="iframe-full-size" [src]="htmlContentUrl"></iframe>